(() => {
  document.querySelectorAll('[data-davids-lp-gallery]').forEach((gallery) => {
    const main = gallery.querySelector('.davids-lp-search-hero__image');
    const thumbs = gallery.querySelectorAll('[data-davids-lp-thumb]');
    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        if (!main) return;
        main.srcset = thumb.dataset.srcset;
        main.src = thumb.dataset.src;
        main.alt = thumb.dataset.alt || '';
        thumbs.forEach((item) => item.removeAttribute('aria-current'));
        thumb.setAttribute('aria-current', 'true');
      });
    });
  });

  const form = document.querySelector('[data-davids-lp-offer]');
  if (!form) return;

  const purchaseInputs = form.querySelectorAll('[data-davids-lp-purchase]');
  const optionInputs = form.querySelectorAll('[data-davids-lp-option]');
  const planSelect = form.querySelector('[data-davids-lp-plan]');
  const frequency = form.querySelector('[data-davids-lp-frequency]');
  const kitNote = form.querySelector('[data-davids-lp-kit-note]');
  const perks = form.querySelector('[data-davids-lp-perks]');
  const sticky = document.querySelector('[data-davids-lp-sticky]');
  const stickyPrice = document.querySelector('[data-davids-lp-sticky-price]');
  const stickyTitle = document.querySelector('[data-davids-lp-sticky-title]');
  const flavorSelect = form.querySelector('[data-davids-lp-flavor-select]');
  const offerSection = form.closest('[data-davids-lp-offer-scope]') || form.closest('.davids-lp-offer');

  const isSubscribe = () => {
    const checked = form.querySelector('[data-davids-lp-purchase]:checked');
    return checked ? checked.value === 'subscribe' : false;
  };

  const selectedOption = () => form.querySelector('[data-davids-lp-option]:checked');

  const rebuildPlans = (option) => {
    if (!planSelect || !option || !option.dataset.plans) return;
    let plans;
    try {
      plans = JSON.parse(option.dataset.plans);
    } catch (error) {
      return;
    }
    const current = planSelect.selectedIndex > -1 ? planSelect.options[planSelect.selectedIndex].text : '';
    const options = plans.map((plan) => {
      const element = new Option(plan.name, plan.id);
      if (plan.name === current) element.selected = true;
      return element;
    });
    planSelect.replaceChildren(...options);
  };

  const update = () => {
    const option = selectedOption();
    rebuildPlans(option);
    const canSubscribe = option && option.dataset.subscribable === 'true';
    const subscribe = isSubscribe() && canSubscribe;

    if (planSelect) planSelect.disabled = !subscribe;
    if (frequency) frequency.hidden = !subscribe;
    if (perks) perks.hidden = !subscribe;
    if (kitNote) kitNote.hidden = !(option && !canSubscribe && isSubscribe());

    optionInputs.forEach((input) => {
      const choice = input.closest('.davids-lp-choice');
      if (!choice || input.dataset.subscribable !== 'true') return;
      const useSub = isSubscribe();
      const price = choice.querySelector('[data-davids-lp-price]');
      const each = choice.querySelector('[data-davids-lp-each]');
      const compare = choice.querySelector('[data-davids-lp-compare]');
      if (price) price.textContent = useSub ? input.dataset.priceSubscribe : input.dataset.priceOnetime;
      if (each) each.textContent = useSub ? input.dataset.eachSubscribe : input.dataset.eachOnetime;
      if (compare) compare.hidden = !useSub;
    });

    if (stickyPrice && option) {
      const price = subscribe ? option.dataset.priceSubscribe : option.dataset.priceOnetime;
      stickyPrice.textContent = `${option.dataset.title} · ${price}${subscribe ? ' with subscribe and save' : ''}`;
    }
  };

  const switchFlavor = () => {
    if (!flavorSelect || !offerSection) return;
    const flavorId = flavorSelect.value;
    const current = selectedOption();
    const keepKit = current && current.hasAttribute('data-davids-lp-kit');
    const size = current && current.dataset.size ? current.dataset.size : '1';

    offerSection.querySelectorAll('[data-davids-lp-flavor]').forEach((panel) => {
      const active = panel.dataset.davidsLpFlavor === flavorId;
      panel.hidden = !active;
      panel.querySelectorAll('[data-davids-lp-option]').forEach((input) => {
        input.disabled = !active || input.dataset.available !== 'true';
      });
    });

    if (!keepKit) {
      const inputs = Array.from(form.querySelectorAll(`[data-davids-lp-flavor="${flavorId}"] [data-davids-lp-option]`)).filter((input) => !input.disabled);
      const match = inputs.find((input) => input.dataset.size === size) || inputs[0];
      if (match) match.checked = true;
    }

    if (stickyTitle) {
      const chosen = flavorSelect.options[flavorSelect.selectedIndex];
      if (chosen && chosen.dataset.stickyTitle) stickyTitle.textContent = chosen.dataset.stickyTitle;
    }
    update();
  };

  if (flavorSelect) flavorSelect.addEventListener('change', switchFlavor);
  purchaseInputs.forEach((input) => input.addEventListener('change', update));
  optionInputs.forEach((input) => input.addEventListener('change', update));
  update();

  if (!sticky || !('IntersectionObserver' in window)) return;

  const hero = document.getElementById('DavidsLpHero');
  const offer = document.getElementById('DavidsLpOffer');
  const state = { heroVisible: true, offerVisible: false };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.target === hero) state.heroVisible = entry.isIntersecting;
      if (entry.target === offer) state.offerVisible = entry.isIntersecting;
    });
    sticky.hidden = state.heroVisible || state.offerVisible;
    document.body.classList.toggle('davids-lp-sticky-on', !sticky.hidden);
    if (!sticky.hidden) document.body.style.setProperty('--davids-lp-sticky-height', `${sticky.offsetHeight}px`);
  });

  if (hero) observer.observe(hero);
  if (offer) observer.observe(offer);
})();
